import { takeEvery, call, put, all, fork, select } from 'redux-saga/effects';
import { PROJECT_DONE, PROJECT_OPEN, actionCreators } from './action';
import { reduxSagaFirebase } from '../../rootFirebase';
import { actionCreators as actionCreatorsTaskList } from "../TasksList/action";

import {user} from '../../selectors/user';

export function* onProjectDoneSaga(action) {
    const idProject = action.payload; 

     const userId = yield select(user);
     
     yield call(reduxSagaFirebase.database.patch, `tasks/${userId}/${idProject}`, {
        done: true
      });

    yield put(actionCreatorsTaskList.fetchTasks());
}

export function* projectDoneSaga() {
	yield takeEvery(PROJECT_DONE, onProjectDoneSaga);
}

export function* onProjectOpenSaga(action) {
    const idProject = action.payload; 

     const userId = yield select(user);
     
     yield call(reduxSagaFirebase.database.patch, `tasks/${userId}/${idProject}`, {
        done: false
      });
      yield put(actionCreatorsTaskList.fetchTasks());
}

export function* projectOpenSaga() {
	yield takeEvery(PROJECT_OPEN, onProjectOpenSaga);
}

export function* projectSaga() {
	yield all([ fork(projectDoneSaga), fork(projectOpenSaga) ]);
}
